import React, { Component, Fragment } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import cx from 'classnames';
import { debounce } from 'lodash';
import { removeHtmlTag } from '../../../lib/common';
import SelectForm from '../../form/SelectForm';
import Tag from '../Tag';
import './EditableTagGroup.scss';

class EditableTagGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tagSearchVisible: false,
    };
  }

  showTagSearchVisible = () => {
    const { tagSearchVisible } = this.state;

    this.setState({
      tagSearchVisible: !tagSearchVisible,
    });
  };

  onChange = (action, tagId) => {
    const { tagSearchSelectList, selectedTagList, onChange, form, name } = this.props;

    let updatedSelectedTagList = [];
    if (action === 'add') {
      const targetTag = tagSearchSelectList.find((item) => item.id === tagId);
      if (targetTag) {
        targetTag.name = removeHtmlTag(targetTag.name);
      }
      updatedSelectedTagList = [...selectedTagList, targetTag];
    } else if (action === 'remove') {
      updatedSelectedTagList = selectedTagList.filter((item) => item.id !== tagId);
    } else {
      updatedSelectedTagList = selectedTagList;
    }

    const updatedSelectedTagIdList = updatedSelectedTagList.map((item) => item.id);

    onChange(updatedSelectedTagList);
    form.setFieldsValue({ [name]: updatedSelectedTagIdList });
  };

  render() {
    const { className, form, name, rules, selectedTagList, tagSearchSelectList, closable, getTagSearchList } =
      this.props;
    const { tagSearchVisible } = this.state;

    return (
      <div className={cx('editable-tag-group', className)}>
        {selectedTagList && selectedTagList.length ? (
          <div className="tag-list">
            {selectedTagList.map((tag) => (
              <Tag key={tag.id} text={tag.name} closable={closable} onClose={() => this.onChange('remove', tag.id)} />
            ))}
          </div>
        ) : null}

        <div className="tag-add-form">
          <Tag
            className={cx('add-tag-button', { hide: tagSearchVisible })}
            onClick={this.showTagSearchVisible}
            isAddHash={false}
            text={
              <Fragment>
                <PlusOutlined /> 태그 추가
              </Fragment>
            }
          ></Tag>

          <SelectForm
            className="tag-input"
            form={form}
            name={name}
            rules={rules}
            mode="multiple"
            initialValue={selectedTagList.map((tag) => tag.id)}
            list={tagSearchSelectList}
            autoFocus={tagSearchVisible}
            showSearch={true}
            filterOption={false}
            autoClearSearchValue={false}
            onSelect={(tagId) => this.onChange('add', tagId)}
            onDeselect={(tagId) => this.onChange('remove', tagId)}
            onInputKeyDown={(e) => {
              /**
               *  백 스페이스를 입력하고 입력한 텍스트가 없는 경우
               */
              if (e.keyCode === 8 && !e.target.value) {
                this.onChange();
              }
            }}
            onBlur={() => this.showTagSearchVisible()}
            onSearch={debounce((keyword) => {
              if (keyword.length) {
                getTagSearchList({
                  keyword: keyword,
                });
              }
            }, 200)}
          />
        </div>
      </div>
    );
  }
}

export default EditableTagGroup;
